import { ISender } from '../../MessageBus/ISender';
import { IMessage } from '../../MessageBus/IMessage';


export class MessagePackage
{
    public Sender?: ISender;
    public Message!: IMessage;
}
